import { ComponentEvents } from "global/interfaces/component.interface";

export const MyMoleculePaginationEvents: ComponentEvents = {
	pageEvent: 'MoleculePaginationEventPage'
}

export interface MoleculePaginationEvent {
	page?: number;
	href?: string;
}
